export default "__VITE_ASSET__4HGKW2tZ__"